import history from 'unsubscribe-ui/utils/history';
import { BREAKPOINTS } from 'unsubscribe-ui/constants';
export const getDataParam = () => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('data') || '';
};
export const getCurrentPathname = () => window.location.pathname;
export const moveToPage = (target, stateData) => history.replace(target, stateData);
export const redirectToUrl = url => {
  window.location.href = url;
};
export const isLocalHostname = hostname =>
// Classic local dev host, plus bend/Conductor worktree dev hosts served as
// `<branch>.local.app.hubspotqa.com`. On both, the preferences API must be
// reached cross-origin at api.hubspotqa.com (see httpClient.getUrl).
// eslint-disable-next-line hubspot-dev/prefer-hubspot-url-utils
hostname === 'local.hubspotqa.com' ||
// eslint-disable-next-line hubspot-dev/prefer-hubspot-url-utils
hostname.endsWith('.local.app.hubspotqa.com');
export const isLocal = () => isLocalHostname(window.location.hostname);
export const isMobileView = () => window.innerWidth < parseInt(BREAKPOINTS.tablet, 10);